import type { ReactNode } from 'react';
import { clientDescriptor, hooks } from '@/store.js';

export default function VerdantProvider({ children }: { children: ReactNode }) {
  return <hooks.Provider value={clientDescriptor}>{children}</hooks.Provider>;
}
